module.exports = __webpack_public_path__ + "static/media/event_calendar.354a84df.svg";